import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = {
  key: 1,
  class: "agent-steps__list"
}
const _hoisted_3 = { class: "agent-steps__text" }
const _hoisted_4 = ["title"]

import { ref } from "vue";
import { Icon } from "@/components/ui";
import type { AgentStep } from "@/dtos/Agent.dto";

// What the agent did during a turn: listed as it happens while the turn runs
// (`live`), then folded into an "N steps" toggle above the reply.

export default /*@__PURE__*/_defineComponent({
  __name: 'AgentSteps',
  props: {
    steps: {},
    live: { type: Boolean }
  },
  setup(__props: any) {



const isOpen = ref(false);

const ICONS: Record<string, string> = {
  search: "mdi:magnify",
  read: "mdi:file-document-outline",
  analyze: "mdi:chart-box-outline",
  linkedin: "mdi:linkedin",
  enrich: "mdi:account-search-outline",
  file: "mdi:file-table-outline",
  task: "mdi:checkbox-marked-circle-outline",
};

const iconFor = (type: string): string => ICONS[type] ?? ICONS.task;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["agent-steps", { 'agent-steps--live': __props.live }])
  }, [
    (!__props.live)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          type: "button",
          class: "agent-steps__toggle",
          "aria-expanded": isOpen.value,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (isOpen.value = !isOpen.value))
        }, [
          _createVNode(_unref(Icon), {
            icon: isOpen.value ? 'mdi:chevron-down' : 'mdi:chevron-right'
          }, null, 8, ["icon"]),
          _createElementVNode("span", null, _toDisplayString(__props.steps.length) + " " + _toDisplayString(__props.steps.length === 1 ? "step" : "steps"), 1)
        ], 8, _hoisted_1))
      : _createCommentVNode("", true),
    (__props.live || isOpen.value)
      ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.steps, (step, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "agent-steps__item"
            }, [
              _createVNode(_unref(Icon), {
                class: "agent-steps__icon",
                icon: iconFor(step.type)
              }, null, 8, ["icon"]),
              _createElementVNode("span", _hoisted_3, _toDisplayString(step.text), 1),
              (step.detail)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 0,
                    class: "agent-steps__detail",
                    title: step.detail
                  }, _toDisplayString(step.detail), 9, _hoisted_4))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})